import Spinner from 'react-bootstrap/Spinner';

import styles from './Loading.module.scss';
import { ReactElement } from 'react';

interface ILoadingProps {
  isLoading: boolean;
  children: ReactElement;
}

const Loading = ({ isLoading, children }: ILoadingProps) => (
  <>
    {isLoading ? (
      <div className={styles.Spinner}>
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </div>
    ) : (
      <>{children}</>
    )}
  </>
);

export default Loading;
